import {
  TOGGLE_LANGUAGE,
  SET_SIDEBAR_STYLE,
  TOGGLE_DARK_MODE,
} from './ActionTypes';

const initialLanguage = localStorage.getItem('language') || "fr";
const darkModeFromLocalStorage = localStorage.getItem('darkMode') === "true"; 

// NEW: read persisted sidebar style or default to 'default'
const initialSidebarStyle = localStorage.getItem('sidebarStyle') || 'default';

const initialState = {
  defaultLanguage: initialLanguage,
  darkMode: darkModeFromLocalStorage,
  sidebarStyle: initialSidebarStyle,
};

const toggleNewItem = (item, localStorageName) => {
  const newItem = !item;
  localStorage.setItem(localStorageName, newItem.toString()); 
  return newItem;
};

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LANGUAGE:
      // Validate payload: only accept known language codes
      if (!['en', 'fr', 'ar'].includes(action.payload)) {
        // Handle error silently
        return state;
      }

      // Update language in both state and localStorage
      localStorage.setItem('language', action.payload);
      return {
        ...state,
        defaultLanguage: action.payload
      };
    case SET_SIDEBAR_STYLE:
      // payload expects: 'default' | 'no-bg-no-border' | 'bg-no-border'
      localStorage.setItem('sidebarStyle', action.payload);
      return {
        ...state,
        sidebarStyle: action.payload
      };
    case TOGGLE_DARK_MODE:
      return {
        ...state,
        darkMode: toggleNewItem(state.darkMode, 'darkMode')
      };
    default:
      return state;
  }
};

export default settingsReducer;
